import { Schema } from 'effect';

export const Location2DSchema = Schema.transform(
  Schema.Struct({
    lat_deg: Schema.String,
    lng_deg: Schema.String
  }),
  Schema.Struct({
    lat: Schema.Number,
    lng: Schema.Number
  }),
  {
    decode: (api) => ({
      lat: Number(api.lat_deg),
      lng: Number(api.lng_deg)
    }),
    encode: (client) => ({
      lat_deg: String(client.lat),
      lng_deg: String(client.lng)
    })
  }
);
export type Location2D = Schema.Schema.Type<typeof Location2DSchema>;

export const Location3DSchema = Schema.Struct({
  lat: Schema.Number,
  lng: Schema.Number,
  alt: Schema.Number
});
export type Location3D = Schema.Schema.Type<typeof Location3DSchema>;
